/* ============================================================
   TWENTY MAE — header overlays: mega menu + overlay coordinator
   One overlay open at a time; Escape closes; focus stays trapped
   inside whichever overlay is open.
   ============================================================ */
(function () {
  'use strict';

  /* Overlay coordinator — also defined (guarded) inline in
     cart-drawer.liquid and header.liquid, since those scripts run
     during parse before this deferred file. First definition wins. */
  window.TMOverlays = window.TMOverlays || {
    _r: {},
    register: function (name, api) { this._r[name] = api; },
    opened: function (name) {
      for (var k in this._r) {
        if (k === name) continue;
        try { if (this._r[k].isOpen()) this._r[k].close(); } catch (e) { /* noop */ }
      }
    }
  };

  /* ---- Focus trap for whichever overlay is open ---- */
  function activeOverlay() {
    var el = document.querySelector('.cd-drawer.is-open');
    if (el) return el;
    var cart = document.querySelector('cart-drawer.is-open');
    if (cart) return cart.querySelector('.msn-cart__panel') || cart;
    var saved = document.getElementById('cd-saved-drawer');
    if (saved && !saved.hasAttribute('hidden')) return saved.querySelector('.cd-saved-drawer__panel') || saved;
    var search = document.querySelector('.cd-search-overlay.is-active');
    if (search) return search;
    return null;
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var box = activeOverlay();
    if (!box) return;
    var nodes = box.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])');
    var f = [];
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].offsetParent !== null || nodes[i] === document.activeElement) f.push(nodes[i]);
    }
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (!box.contains(document.activeElement)) {
      e.preventDefault(); first.focus();
    } else if (e.shiftKey && document.activeElement === first) {
      e.preventDefault(); last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault(); first.focus();
    }
  });

  /* ---- Desktop mega menu ---- */
  var mq = window.matchMedia('(min-width: 990px)');
  var CLOSE_GRACE = 180; /* ms of forgiveness when the cursor leaves */
  var closeTimer = null;
  var openKey = null;

  function panelFor(key) {
    return document.querySelector('.tm-mega[data-mega-panel="' + key + '"]');
  }
  function itemFor(key) {
    return document.querySelector('.cd-desknav__item[data-mega="' + key + '"]');
  }

  function closeMega() {
    clearTimeout(closeTimer);
    if (openKey === null) return;
    var p = panelFor(openKey), it = itemFor(openKey);
    if (p) { p.classList.remove('is-open'); p.setAttribute('aria-hidden', 'true'); }
    if (it) it.classList.remove('is-mega-open');
    document.documentElement.classList.remove('tm-mega-open');
    openKey = null;
  }

  function openMega(key) {
    clearTimeout(closeTimer);
    if (openKey === key) return;
    if (window.TMOverlays) window.TMOverlays.opened('mega');
    if (openKey !== null) {
      var pp = panelFor(openKey), pi = itemFor(openKey);
      if (pp) { pp.classList.remove('is-open'); pp.setAttribute('aria-hidden', 'true'); }
      if (pi) pi.classList.remove('is-mega-open');
    }
    var p = panelFor(key), it = itemFor(key);
    if (!p) return;
    p.classList.add('is-open');
    p.setAttribute('aria-hidden', 'false');
    if (it) it.classList.add('is-mega-open');
    document.documentElement.classList.add('tm-mega-open');
    openKey = key;
  }

  function scheduleClose() {
    clearTimeout(closeTimer);
    closeTimer = setTimeout(closeMega, CLOSE_GRACE);
  }

  function init() {
    var items = document.querySelectorAll('.cd-desknav__item[data-mega]');
    if (!items.length) return;
    items.forEach(function (it) {
      var key = it.getAttribute('data-mega');
      it.addEventListener('mouseenter', function () { if (mq.matches) openMega(key); });
      it.addEventListener('mouseleave', function () { if (mq.matches) scheduleClose(); });
      var link = it.querySelector('.cd-desknav__link');
      if (link) link.addEventListener('focus', function () { if (mq.matches) openMega(key); });
    });
    document.querySelectorAll('.tm-mega').forEach(function (p) {
      p.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
      p.addEventListener('mouseleave', function () { scheduleClose(); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeMega();
    });
    window.addEventListener('scroll', function () { if (openKey !== null) closeMega(); }, { passive: true });
    document.addEventListener('click', function (e) {
      if (openKey === null) return;
      if (e.target.closest('.tm-mega') || e.target.closest('.cd-desknav__item[data-mega]')) return;
      closeMega();
    });
    if (!mq.matches) closeMega();
    mq.addEventListener('change', function (ev) { if (!ev.matches) closeMega(); });
    window.TMOverlays.register('mega', {
      isOpen: function () { return openKey !== null; },
      close: closeMega
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ============================================================
   Drawer predictive search — /search/suggest.json while typing.
   Rows mirror the cart drawer line-item look (3/4 thumb, uppercase
   name, tabular price). Products only; no business facts invented.
   ============================================================ */
(function () {
  'use strict';

  function init() {
    var form = document.querySelector('.tm-mdrawer__search');
    var input = document.querySelector('.tm-mdrawer__search-input');
    var panel = document.getElementById('tm-drawer-search-results');
    if (!form || !input || !panel) return;

    var timer = null;
    var ctrl = null;
    var lastQ = '';

    function esc(s) {
      var d = document.createElement('div');
      d.textContent = s == null ? '' : String(s);
      return d.innerHTML;
    }

    function thumb(url) {
      if (!url) return '';
      return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=128';
    }

    function money(p) {
      /* suggest.json returns plain strings like "89.95" — the shop's saved
         money format is broken (see cart drawer), so format here. */
      var n = parseFloat(p);
      if (isNaN(n)) return '';
      return '€' + n.toFixed(2);
    }

    function hide() {
      panel.hidden = true;
      panel.innerHTML = '';
      input.setAttribute('aria-expanded', 'false');
    }

    function render(q, products) {
      var html = '';
      if (!products.length) {
        html = '<p class="tm-psr__none">No results for “' + esc(q) + '”</p>';
      } else {
        for (var i = 0; i < products.length; i++) {
          var p = products[i];
          var img = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
          html +=
            '<a class="tm-psr__item" role="option" href="' + esc(p.url) + '">' +
              '<span class="tm-psr__media">' +
                (img ? '<img class="tm-psr__img" src="' + esc(thumb(img)) + '" alt="" loading="lazy">' : '') +
              '</span>' +
              '<span class="tm-psr__info">' +
                '<span class="tm-psr__name">' + esc(p.title) + '</span>' +
                '<span class="tm-psr__price">' + money(p.price) + '</span>' +
              '</span>' +
            '</a>';
        }
        html += '<a class="tm-psr__all" href="/search?q=' + encodeURIComponent(q) + '&type=product&options%5Bprefix%5D=last">View all results &rarr;</a>';
      }
      panel.innerHTML = html;
      panel.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }

    function fetchResults(q) {
      if (ctrl) ctrl.abort();
      ctrl = ('AbortController' in window) ? new AbortController() : null;
      var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=5&resources[options][unavailable_products]=last';
      fetch(url, ctrl ? { signal: ctrl.signal } : {})
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (q !== lastQ) return;
          var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
          render(q, products);
        })
        .catch(function (e) { if (e && e.name !== 'AbortError') hide(); });
    }

    input.addEventListener('input', function () {
      var q = input.value.trim();
      lastQ = q;
      clearTimeout(timer);
      if (q.length < 2) { hide(); return; }
      timer = setTimeout(function () { fetchResults(q); }, 220);
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !panel.hidden) { hide(); e.stopPropagation(); }
    });

    /* Reset when the drawer closes so it reopens clean. */
    var drawer = document.getElementById('cd-drawer');
    if (drawer && 'MutationObserver' in window) {
      new MutationObserver(function () {
        if (!drawer.classList.contains('is-open')) { hide(); input.value = ''; }
      }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
